/**
 * Il riepilogo è renderizzato solo lato PDF e non è visibile in compilazione
 */
export function SecondaryResumeWidgetComponent() {
  return null;
}
